/**
 * @generated SignedSource<<6ce5c097ea632f3279285fa70c757002>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type SubscriptionState = "POST_SUBSCRIBED" | "POST_TRIAL" | "SUBSCRIBED" | "TRIAL";
import { FragmentRefs } from "relay-runtime";
export type UpgradeLink_viewer$data = {
  readonly account: {
    readonly billingAccount: {
      readonly id: string;
      readonly noteLimit: number | null;
      readonly restrictedMetrics: any | null;
      readonly subscriptionProductName: string;
      readonly subscriptionStartDate: string | null;
      readonly subscriptionState: SubscriptionState;
      readonly subscriptionTrialEnd: string | null;
      readonly subscriptionTrialIsSoft: boolean;
      readonly subscriptionTrialLength: number;
    };
    readonly id: string;
  };
  readonly " $fragmentType": "UpgradeLink_viewer";
};
export type UpgradeLink_viewer$key = {
  readonly " $data"?: UpgradeLink_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"UpgradeLink_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "UpgradeLink_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Account",
      "kind": "LinkedField",
      "name": "account",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "BillingAccount",
          "kind": "LinkedField",
          "name": "billingAccount",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "subscriptionState",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "subscriptionProductName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "subscriptionStartDate",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "subscriptionTrialEnd",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "subscriptionTrialLength",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "subscriptionTrialIsSoft",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "restrictedMetrics",
              "storageKey": null
            },
            {
              "alias": "noteLimit",
              "args": [
                {
                  "kind": "Literal",
                  "name": "feature",
                  "value": "history"
                }
              ],
              "kind": "ScalarField",
              "name": "usageLimitForFeature",
              "storageKey": "usageLimitForFeature(feature:\"history\")"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "ed7fba0e088eb5a0d13f8b5e615ffa4d";

export default node;
